import axiosInstance from "./axiosInstance";

// POST
export const axiosPost = async (endpoint, body = {}, headers = {}, params = {}) => {
    try {
        const response = await axiosInstance.post(endpoint, body, {
            headers,
            params,
        });
        return response;
    } catch (error) {
        console.error("POST error:", error);
        throw error;
    }
};

// GET
export const axiosGet = async (endpoint, params = {}, headers = {}, options = {}) => {
    try {
        const response = await axiosInstance.get(endpoint, {
            headers,
            params,
            ...options,
        });
        return response;
    } catch (error) {
        console.error("GET error:", error);
        throw error;
    }
};

// PUT
export const axiosPut = async (endpoint, body = {}, headers = {}, params = {}) => {
    try {
        const response = await axiosInstance.put(endpoint, body, {
            headers,
            params,
        });
        return response;
    } catch (error) {
        console.error("PUT error:", error);
        throw error;
    }
};

// DELETE
export const axiosDelete = async (endpoint, params = {}, headers = {}) => {
    try {
        const response = await axiosInstance.delete(endpoint, {
            headers,
            params,
        });
        return response;
    } catch (error) {
        console.error("DELETE error:", error);
        throw error;
    }
};
